/**
 * Copyright 2025 Beijing Volcano Engine Technology Co., Ltd. All Rights Reserved.
 * SPDX-license-identifier: BSD-3-Clause
 */

import style from './index.module.less';

function AIChangeCard() {

  return (
    <div className={style.card}>
      <div className={style.avatar}>
        <img id="avatar-card" src="https://cdn.boyakids.cn/upload/20250724/dbcc755e6def2789ad1b36e5bdd752a5.png" alt="Avatar" />
      </div>
      <div className={style.title}>
        <div>Hi，让我们来探讨这篇文章吧</div>
        <div className={style.desc}>
          点击下方通话按钮开启聊天<br/><br/><br/>
        </div>
      </div>
    </div>
  );
}

export default AIChangeCard;
